import {
  ADD_PROMO_SUCCESS,
  VIEW_PROMO_SUCCESS,
  GET_PROMO_SUCCESS,
} from "../constants";

const initialState = {
  promoCodes: [],
  promoDetails: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PROMO_SUCCESS:
      return {};
    case VIEW_PROMO_SUCCESS:
      return { ...initialState, promoCodes: action.data };

    case GET_PROMO_SUCCESS:
      return { ...initialState, promoDetails: action.data };

    default:
      return state;
  }
};

export default reducer;
